import React, { useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { Spinner, Alert, Button } from "react-bootstrap";
import axios from "axios";
import { useDispatch } from "react-redux";
import { getPaymentStatus } from "../../../../slices/thunk";
import { primaryColor } from "Common/commaon";
import apiUrl from "slices/apiEndpoint";
import { getDecodeId } from "slices/userProfile/thunk";
import api from "Common/api";
axios.defaults.baseURL = "/api";
interface StripeProps {
  userEmail: string;
  onCancel?: any;
  setStatus?: any;
  onSuccess?:any;
  hasSavedCards?: boolean;
}

const StripeForm: React.FC<StripeProps> = ({
  userEmail,
  onCancel,
  setStatus,
  onSuccess,
  hasSavedCards = false,
}) => {
  const stripe: any = useStripe();
  const elements: any = useElements();
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [isPrimary, setIsPrimary] = useState(!hasSavedCards);
  const [notification, setNotification] = useState({
    show: false,
    variant: "",
    message: "",
  });
const userId = getDecodeId()


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setNotification({ show: false, variant: "", message: "" });

    if (!stripe || !elements) {
      setNotification({
        show: true,
        variant: "danger",
        message: "Stripe not loaded properly.",
      });
      return;
    }

    const cardElement = elements.getElement(CardElement);

    if (!cardElement) {
      setNotification({
        show: true,
        variant: "danger",
        message: "Card input is missing. Please refresh and try again.",
      });
      return;
    }

    setLoading(true);
    setLoadingMessage("Securing card details…");

    try {
      const { token, error } = await stripe.createToken(cardElement, {
        name: userEmail,
      });

      if (error || !token) {
        setNotification({
          show: true,
          variant: "danger",
          message: error?.message || "Failed to secure card details.",
        });
        return;
      }

      setLoadingMessage("Saving card…");
      const savedCard: any = await api.post(`/stripe/api/stripe-payment`, {
        token,
        email: userEmail,
        amount: 999, // Replace with your amount
        userId:userId ,
        setPrimary: isPrimary,
      });
      if (setStatus) {
        setStatus(false);
      }
      if(onSuccess){onSuccess(savedCard)}
      await dispatch(getPaymentStatus());
    } catch (err: any) {
      console.log(err)
      setNotification({
        show: true,
        variant: "danger",
        message:
          err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.error ||
          "Card could not be saved. Please try again.",
      });
    } finally {
      setLoading(false);
      setLoadingMessage("");
    }
  };
  return (
    <div className="tailwind-prefix">
      {loading && (
        <Alert variant="info" role="status" aria-live="polite" className="d-flex align-items-center gap-2">
          <Spinner animation="border" size="sm" aria-hidden="true" />
          <span>{loadingMessage}</span>
        </Alert>
      )}

      <>
        {notification.show && (
          <Alert
            variant={notification.variant}
            onClose={() =>
              setNotification({ show: false, variant: "", message: "" })
            }
            dismissible
          >
            {notification.message}
          </Alert>
        )}

        <form onSubmit={handleSubmit} className="space-y-4" aria-busy={loading}>
          <input
            type="email"
            value={userEmail}
            disabled
            className="w-full p-2 border rounded"
          />

          <CardElement
            options={{
              disabled: loading,
              style: {
                base: {
                  fontSize: "14px",
                  color: "#424770",
                  "::placeholder": {
                    color: "#aab7c4",
                  },
                },
                invalid: {
                  color: "#9e2146",
                },
              },
            }}
            className="w-full p-2 border rounded"
          />

          <fieldset disabled={loading} className="space-y-2">
            <legend className="text-sm font-semibold mb-2">Card priority</legend>
            <label className="flex items-start gap-2 rounded border p-3 cursor-pointer">
              <input
                type="radio"
                name="card-priority"
                value="primary"
                checked={isPrimary}
                onChange={() => setIsPrimary(true)}
                className="mt-1"
              />
              <span>
                <strong className="block">Primary card</strong>
                <small className="text-muted">Use this card by default for future payments.</small>
              </span>
            </label>
            <label className="flex items-start gap-2 rounded border p-3 cursor-pointer">
              <input
                type="radio"
                name="card-priority"
                value="secondary"
                checked={!isPrimary}
                onChange={() => setIsPrimary(false)}
                className="mt-1"
              />
              <span>
                <strong className="block">Secondary card</strong>
                <small className="text-muted">Save as a backup without changing the primary card.</small>
              </span>
            </label>
          </fieldset>

          <div className="flex space-x-2">
            <Button
              type="submit"
              disabled={!stripe || loading}
              className="btn-primary bg-gradient"
            >
              {loading ? (
                <span className="d-inline-flex align-items-center gap-2">
                  <Spinner animation="border" size="sm" aria-hidden="true" />
                  {loadingMessage}
                </span>
              ) : "Add Card"}
            </Button>
            <Button type="button" onClick={onCancel} disabled={loading} className="btn-light bg-gradient">
              Cancel
            </Button>
          </div>
        </form>
      </>
    </div>
  );
};

export default StripeForm;
